// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"48d3acb1","885":"28514ae3"}[chunkId] + ".chunk.js";
};